import i18next from "i18next";
import usFlag from "#src/assets/images/flags/us.png";
import vnFlag from "#src/assets/images/flags/vn.png";
import { Flag } from "#src/common/Flag";
import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";

const fixedTFunc = i18next.getFixedT(null, "common", "languages");

export const LANGUAGE_LIST: {
  key: string;
  searchValue: string;
  getLabel: () => string;
  flag: JSX.Element;
}[] = [
  {
    key: "en",
    searchValue: "english",
    getLabel: () => fixedTFunc("english"),
    flag: <Flag pngProp={usFlag} />,
  },
  {
    key: "vi",
    searchValue: "vietnamese",
    getLabel: () => fixedTFunc("vietnamese"),
    flag: <Flag pngProp={vnFlag} />,
  },
];

export const languageItemsV2: IFilterItemV2[] = [
  {
    key: "en",
    value: "en",
    getLabel: () => fixedTFunc("english"),
    leftIcon: (
      <img src={usFlag} className="object-contain rounded-full h-5 w-5" />
    ),
  },
  {
    key: "vi",
    value: "vi",
    getLabel: () => fixedTFunc("vietnamese"),
    leftIcon: (
      <img src={vnFlag} className="object-contain rounded-full h-5 w-5" />
    ),
  },
];
